<template>
  <el-row class="receipt_framework">
    <el-table :data="orderList" style="width: 100%" @selection-change="selectOrder">
      <template slot="empty">
        <span class="emptyText">暂无待配送订单信息</span>
      </template>
      <el-table-column align="center" type="selection" width="18">
      </el-table-column>
      <el-table-column align="left" width="400">
        <template slot="header">
          <el-row>
            <el-button-group>
              <el-button class="small_button" size="small" type="primary" @click="clickAllOrder">确认收货</el-button>
            </el-button-group>
          </el-row>
        </template>
        <template slot-scope="scope">
          <el-card class="order_card" shadow="hover">
            <el-row>
              <div class="clearfix">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="24">
                      <p class="order_title">待配送订单&nbsp;#{{scope.row.id.substring(scope.row.id.length-4)}}</p>
                    </el-col>
                    <el-col :span="24">
                      <p class="order_address">{{scope.row.addressDetail + '--' + scope.row.addressNote}}</p>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-button class="order_status" type="text">
                    <span>进行中</span>
                  </el-button>
                </el-col>
              </div>
            </el-row>
            <el-divider></el-divider>
            <order-card :orderInfo=scope.row></order-card>
            <el-button class="button" type="primary" @click="clickOrder(scope.row)">确认收货</el-button>
          </el-card>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageData.currentPage" :page-sizes="[5, 10, 50, 100]" :page-size="pageData.pageSize" :total="pageData.totalSize" layout="sizes, prev, pager, next, total" @size-change="changeSize" @current-change="changeCurrent">
    </el-pagination>
  </el-row>
</template>

<script>
  import OrderCard from "../OrderCard.vue"
  import DataUntils from "@/utils/data.js";

  export default {
    name: "PendingReceipt",
    components: {
      OrderCard,
    },
    data() {
      return {
        orderStatus: {
          status: "待收货"
        },
        orderList: [],
        orderSelection: [],
        pageData: {
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示条目个数
          totalSize: 0, //总条目数
        }
      };
    },
    created() {
      this.getOrderList();
    },
    mounted() {},
    watch: {
      // orderList: {
      //   handler: function () {
      //     this.$emit('receiptCount', this.pageData.totalSize);
      //   }
      // }
      "pageData.totalSize"() {
        // this.$emit('receiptCount', this.pageData.totalSize);
        this.getOrderList();
      }
    },
    methods: {
      getOrderList() {
        DataUntils
          .getOrderListByStatus({
            status: this.orderStatus.status,
            page:this.pageData.currentPage,
            pageSize: this.pageData.pageSize
          })
          .then((res) => {
            this.orderList = res.orderList;
            // this.pageData = res.pageData;
            this.pageData.totalSize = res.pageData.totalSize;
          })
      },
      async clickOrder(val) {
        await DataUntils
          .serveOrderByID({
            orderId: val.id
          });
        this.$notify({
          title: '订单确认收货通知',
          message: `订单#${val.id.substring(val.id.length-4)}已确认收货`,
          duration: 3000
        });
        // this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
        this.getOrderList();
      },
      clickAllOrder() {
        if (this.orderSelection.length == 0) {
          this.$message({
            message: '未选择订单',
            type: 'error'
          });
        }
        else {
          this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: "success",
            })
            .then(() => {
              let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils
                  .serveOrderByID({
                    orderId: this.orderSelection[i].id
                  });
                orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
              this.$notify({
                title: '订单确认收货通知',
                message: `${this.orderSelection.length}件订单已确认收货`,
                duration: 3000
              });
              this.getOrderList();
            });
        }
      },
      selectOrder(val) {
        this.orderSelection = val;
      },
      // 每页显示条目个数更改
      changeSize(pageSize) {
        this.pageData.pageSize = pageSize;
        this.pageData.currentPage = 1;
        this.getOrderList();
      },
      // 当前页数更改
      changeCurrent(currentPage) {
        this.pageData.currentPage = currentPage;
        this.getOrderList();
      },
    },
  };
</script>

<style>
  @import "../../../../style/Order.css";
</style>
